import { Avatar, makeStyles, Spinner, tokens } from "@fluentui/react-components";
import { BotRegular } from "@fluentui/react-icons";
import React from "react";

export const LoadingAssistantMessageBubble: React.FC = () => {
  const classes = useStyles();
  return (
    <div className={classes.wrapper}>
      <div className={classes.messageWrapper}>
        <div className={classes.assistantIcon}>
          <Avatar icon={<BotRegular />} />
        </div>
        <div className={classes.message}>
          <Spinner size="extra-tiny" />
        </div>
      </div>
    </div>
  );
};

const useStyles = makeStyles({
  wrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
  },
  captionWrapper: {
    paddingLeft: "34px",
    height: "20px",
    alignItems: "space-between",
    display: "flex",
    gap: tokens.spacingHorizontalXS,
  },
  assistantName: {
    fontSize: tokens.fontSizeBase200,
  },
  datetime: {
    fontSize: tokens.fontSizeBase200,
  },
  messageWrapper: {
    display: "flex",
  },
  assistantIcon: {
    width: "34px",
  },
  message: {
    background: tokens.colorNeutralBackground3,
    fontSize: tokens.fontSizeBase300,
    borderRadius: tokens.borderRadiusMedium,
    padding: `${tokens.spacingVerticalM} ${tokens.spacingHorizontalL}`,
    width: "100px",
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingHorizontalS,
  },
  actions: {
    fontSize: tokens.fontSizeBase400,
    display: "flex",
    gap: tokens.spacingHorizontalXXS,
  },
  choices: {
    paddingLeft: "34px",
    paddingTop: tokens.spacingHorizontalS,
  },
});
